import React, { useRef, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import functions from '../../firebase/functions';
import { CLUB } from '../../utils/constants';

const EMPTY = { name: '', email: '', message: '', website: '' };

export default function Contact() {
  const [form, setForm] = useState(EMPTY);
  const [phase, setPhase] = useState('idle'); // idle | sending | done | error
  const [errorMsg, setErrorMsg] = useState('');
  // Doppelter Riegel gegen Doppel-Absenden: `disabled` am Button greift erst
  // nach dem Re-Render, ein Ref sofort.
  const sendingRef = useRef(false);

  function update(field, value) {
    setForm((prev) => ({ ...prev, [field]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (sendingRef.current) return;
    sendingRef.current = true;
    setPhase('sending');
    setErrorMsg('');

    try {
      if (!functions) {
        throw new Error(
          'Das Formular ist gerade nicht verfügbar. Schreib uns bitte direkt per Mail.'
        );
      }
      await httpsCallable(functions, 'sendContactMessage')(form);
      setForm(EMPTY);
      setPhase('done');
    } catch (err) {
      setErrorMsg(
        err?.message || 'Die Nachricht konnte nicht gesendet werden. Bitte versuch es später erneut.'
      );
      setPhase('error');
    } finally {
      sendingRef.current = false;
    }
  }

  return (
    <section className="mt-section mt-section--alt" id="kontakt">
      <div className="mt-container mt-contact">
        <div className="mt-contact__intro">
          <span className="mt-kicker">Kontakt</span>
          <h2>Sag Hallo</h2>
          <p>
            Frage zur Community, Lust auf eine Ausfahrt oder eine Idee für ein Treffen? Schreib
            uns - wir antworten meist innerhalb weniger Tage.
          </p>
          <p>
            Lieber direkt per Mail?{' '}
            <a href={`mailto:${CLUB.email}`} className="mt-contact__mail">
              {CLUB.email}
            </a>
          </p>
        </div>

        <form className="mt-card mt-contact__form" onSubmit={handleSubmit}>
          {phase === 'done' && (
            <div className="mt-alert mt-alert--ok" role="status">
              Danke! Deine Nachricht ist angekommen.
            </div>
          )}
          {phase === 'error' && (
            <div className="mt-alert mt-alert--error" role="alert">
              {errorMsg}
            </div>
          )}

          <label className="mt-field">
            <span className="mt-label">Name</span>
            <input
              type="text"
              className="mt-input"
              value={form.name}
              onChange={(e) => update('name', e.target.value)}
              required
              maxLength={80}
              autoComplete="name"
            />
          </label>

          <label className="mt-field">
            <span className="mt-label">E-Mail</span>
            <input
              type="email"
              className="mt-input"
              value={form.email}
              onChange={(e) => update('email', e.target.value)}
              required
              maxLength={120}
              autoComplete="email"
            />
          </label>

          <label className="mt-field">
            <span className="mt-label">Nachricht</span>
            <textarea
              className="mt-textarea"
              value={form.message}
              onChange={(e) => update('message', e.target.value)}
              required
              maxLength={2000}
            />
          </label>

          {/* Honeypot: für Menschen unsichtbar. Ein ausgefülltes Feld
              beantwortet der Server mit einer Erfolgsmeldung und speichert
              nichts - eine Fehlermeldung wäre für einen Bot die Auskunft,
              dass die Falle erkannt wurde. */}
          <div className="mt-hp" aria-hidden="true">
            <label>
              Website
              <input
                type="text"
                tabIndex={-1}
                autoComplete="off"
                value={form.website}
                onChange={(e) => update('website', e.target.value)}
              />
            </label>
          </div>

          <button
            type="submit"
            className="mt-btn mt-btn--primary mt-btn--block"
            disabled={phase === 'sending'}
          >
            {phase === 'sending' ? 'Wird gesendet …' : 'Nachricht senden'}
          </button>

          <p className="mt-hint">
            Mit dem Absenden stimmst du der Verarbeitung deiner Angaben zur Bearbeitung der
            Anfrage zu. Details in der Datenschutzerklärung.
          </p>
        </form>
      </div>
    </section>
  );
}
